module.exports = __webpack_public_path__ + "img/exam_mainBack.2db641f5.png";